import { useState } from "react";
import { ChevronsUpDown, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandEmpty, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";

export default function CostCodeCombobox({ value, costCodes, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const sel = (costCodes || []).find((c) => c.id === value);
  const pick = (id) => { onChange(id); setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
                className="flex h-7 w-full items-center justify-between rounded border border-slate-200 bg-white px-1.5 text-left text-xs">
          <span className={`truncate ${sel ? "text-slate-700" : "text-slate-400"}`}>
            {sel ? `${sel.code} — ${sel.name}` : "No cost code (unmapped)"}
          </span>
          <ChevronsUpDown className="h-3 w-3 shrink-0 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="start">
        <Command>
          <CommandInput placeholder="Search cost codes…" className="h-8 text-xs"
                        data-testid={`${testid}-search`} />
          <CommandList className="max-h-60">
            <CommandEmpty className="py-3 text-center text-xs text-slate-400">No match.</CommandEmpty>
            <CommandItem value="no cost code unmapped" onSelect={() => pick("")}
                         className="text-xs" data-testid={`${testid}-none`}>
              <Check className={`mr-1.5 h-3 w-3 ${!value ? "opacity-100" : "opacity-0"}`} />
              No cost code (unmapped)
            </CommandItem>
            {(costCodes || []).map((c) => (
              <CommandItem key={c.id} value={`${c.code} ${c.name} ${c.id}`} onSelect={() => pick(c.id)}
                           className="text-xs" data-testid={`${testid}-opt-${c.id}`}>
                <Check className={`mr-1.5 h-3 w-3 ${value === c.id ? "opacity-100" : "opacity-0"}`} />
                <span className="font-mono">{c.code}</span>&nbsp;— {c.name}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
